export default class ElementSelection {
  elementId = null;
  sectionId = null;
  constructor({ elementId, sectionId }) {
    this.elementId = elementId;
    this.sectionId = sectionId;
  }
}
